import { useCallback } from 'react'
import { feedback } from '../../../core/feedback'
import { requests } from '../../../core/ajax'
import { useIntl } from 'react-intl'
import { setObfuscationToken } from '../../global'
import { useDispatch } from 'react-redux'

export const useInvoicesCalls = () => {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()

  const noResponseError = () =>
    feedback('error', formatMessage({ id: 'calls.responseless.error.description' }))
  const defaultError = () =>
    feedback('error', formatMessage({ id: 'calls.default.error.description' }))

  const getInvoices = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        requests
          .invoices(config)
          .then((response) => {
            if (response) {
              if (response.status === 206) {
                dispatch(setObfuscationToken(null))
              }
              resolve(response)
            } else {
              noResponseError()
              return reject('No response')
            }
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 400:
                feedback('error', response.data.message)
                break
              case 403:
                break
              case 503:
                dispatch(setObfuscationToken(null))
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    []
  )

  const getInvoicePdf = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        requests
          .invoiceDoc(config)
          .then((response) => {
            if (response) {
              resolve(response)
            } else {
              noResponseError()
              return reject('No response')
            }
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 400:
                break
              case 404:
                feedback('error', formatMessage({ id: 'calls.invoice.error.notFound' }))
                break
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    []
  )

  const getInvoicePaymentPdf = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        requests
          .paymentReceipt(config)
          .then((response) => {
            if (response) {
              resolve(response)
            } else {
              noResponseError()
              return reject('No response')
            }
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 400:
                feedback('error', response.data.message)
                break
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    []
  )

  const payInvoices = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        requests
          .payinvoices(config)
          .then((response) => {
            if (response && response.data.Ds_MerchantParameters) {
              resolve({
                merchantParams: response.data.Ds_MerchantParameters,
                signature: response.data.Ds_Signature,
                signatureVersion: response.data.Ds_SignatureVersion,
              })
            } else {
              noResponseError()
              return reject('No response')
            }
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 400:
              case 403:
              case 429:
                feedback('error', response.data.message)
                break
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    []
  )

  return {
    getInvoices,
    getInvoicePdf,
    getInvoicePaymentPdf,
    payInvoices,
  }
}
